import { oneOf } from 'prop-types'
import { kuiperClassNames } from '../utils'

import './styles.scss'

const StatusDot = ({ status = 'inactive' }) => (
  <div className={kuiperClassNames('status-dot', status)} />
)

StatusDot.propTypes = {
  status: oneOf([
    'inactive',
    'warning',
    'success',
    'error',
    'placeholder',
    'new',
  ]),
}

export default StatusDot
